import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import VersionChecker from './utils/versionChecker';

// Register service worker for PWA functionality and version checking
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('[SW] Service Worker registered successfully:', registration.scope);
        
        // Initialize version checker after service worker is ready
        VersionChecker.getInstance().init();
      })
      .catch((error) => {
        console.log('[SW] Service Worker registration failed:', error);
        
        // Still initialize version checker even if SW registration fails
        VersionChecker.getInstance().init();
      });
  });
} else {
  // Initialize version checker even if service workers are not supported
  VersionChecker.getInstance().init();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
